import { CssRender as t } from "./ghl-ui.es370.js";
import { plugin as i } from "./ghl-ui.es371.js";
const p = "n", r = `.${p}-`, u = "__", d = "--", s = t(), c = i({
  blockPrefix: r,
  elementPrefix: u,
  modifierPrefix: d
});
s.use(c);
const { c: e, find: m } = s, { cB: f, cE: $, cM: x, cNotM: M } = c;
function g(o) {
  return e(({ props: { bPrefix: n } }) => `${n || r}modal, ${n || r}drawer`, [o]);
}
function P(o) {
  return e(({ props: { bPrefix: n } }) => `${n || r}popover`, [o]);
}
function v(o) {
  return e(({ props: { bPrefix: n } }) => `&${n || r}modal`, o);
}
const B = (...o) => e(">", [f(...o)]);
export {
  v as asModal,
  e as c,
  f as cB,
  B as cCB,
  $ as cE,
  x as cM,
  M as cNotM,
  m as find,
  g as insideModal,
  P as insidePopover,
  p as namespace,
  r as prefix
};
